var Ajax = new (class {

  constructor() {
  }

  init(postUrl, getDefaultParameters) {
    this._post_url = postUrl;
    this._get_default_parameters = getDefaultParameters;
  }

  call(url, data = {}, method = 'POST') {
    return new Promise((resolve, reject) => {
      if (!this._post_url)
        reject("Can't make ajax call. The post url is empty");
      try {
        // Apply default parameters
        let defaultParameters = this._get_default_parameters();
        Object.keys(defaultParameters).forEach((key) => {
          if (this._exists(defaultParameters, key) && !this._exists(data, key)) {
            data[key] = defaultParameters[key];
          }
        });

        if (Utils.isIe9) {
          let xdr = new XDomainRequest();

          xdr.onload = function() {
            try {
              resolve(JSON.parse(xdr.responseText));
            } catch (ajaxError) {
              reject(ajaxError);
            }
          };

          xdr.onerror = function(e) {
            Utils.log(e);
            reject(new Error('Network error'));
          };
          xdr.onprogress = function() {};

          xdr.open(method, this._post_url + url);
          xdr.send(JSON.stringify(data));
        }
        else {
          let ajaxRequest = this._getRequest();

          ajaxRequest.onload = function() {
            if (ajaxRequest.readyState == 4) {
              if (ajaxRequest.status === 204) {
                try {
                  resolve({ success: true });
                } catch (ajaxError) {
                  reject(ajaxError);
                }
              }
              if (ajaxRequest.status >= 200 && ajaxRequest.status < 300) {
                try {
                  resolve(JSON.parse(ajaxRequest.responseText));
                } catch (ajaxError) {
                  reject(ajaxError);
                }
              }
              else if (ajaxRequest.status >= 400) {
                try {
                  let parsedResponse = JSON.parse(ajaxRequest.responseText);
                  if (parsedResponse) {
                    if ((parsedResponse.error || !parsedResponse.success) && parsedResponse.message) {
                      Utils.publicWarn(ajaxRequest.status + ": " + parsedResponse.message);
                    }
                    reject(parsedResponse);
                  }
                  else reject(ajaxRequest.responseText);
                } catch (e) {
                  reject(ajaxRequest.responseText);
                }
              }
            }
          };

          ajaxRequest.onerror = function() {
            reject(new Error('Network error'));
          };

          ajaxRequest.ontimeout = function() {
            reject(new Error('Request timeout'));
          };

          ajaxRequest.open(method, this._post_url + url, true);
          ajaxRequest.timeout = 30000;
          ajaxRequest.setRequestHeader("Content-Type", "text/plain");
          ajaxRequest.send(JSON.stringify(data));
        }
      } catch(e) {
        console.error(e);
        reject(e);
      }
    });
  }

  _getRequest() {
    let ajaxRequest;

    try {
      ajaxRequest = new XMLHttpRequest();
    } catch (e) {
      try {
        ajaxRequest = new ActiveXObject("Msxml2.XMLHTTP");
      } catch (e) {
        try {
          ajaxRequest = new ActiveXObject("Microsoft.XMLHTTP");
        } catch (e){
          throw "Browser can't make ajax call";
        }
      }
    }

    return ajaxRequest;
  }

  _exists(obj, property) {
    return obj && typeof obj[property] != "undefined" && obj[property] != null;
  }

});
